import { Outlet } from 'react-router-dom'

import { SalaryAdvanceSettingsPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import PageLoading from 'modules/layout/components/Page/Loading'

const RootPage = () => {
  const { data, loading } = useQuery(SalaryAdvanceSettingsPageDocument)

  const canManageSalaryAdvance = data?.salaryAdvance?._policies?.manageSalaryAdvance?.can
  const canManagePayments = data?.finance?._policies?.sidebarSeeFinancePaymentsSubLevelItem?.can
  const canViewSettings = canManageSalaryAdvance || canManagePayments

  if (loading) {
    return <PageLoading />
  }

  return (
    <AuthorizeUser authorizeFn={() => canViewSettings ?? false}>
      <Outlet />
    </AuthorizeUser>
  )
}

export default RootPage
